import { useEffect, useState } from 'react'
import { Download } from 'lucide-react'

const InstallAppPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setVisible(true)
    }

    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  if (!visible || !deferredPrompt) return null

  const handleInstallClick = async () => {
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    if (outcome === 'accepted') {
      setVisible(false)
      setDeferredPrompt(null)
    }
  }

  return (
    <div className="fixed bottom-4 right-4 z-[100003]">
      <button
        type="button"
        onClick={handleInstallClick}
        className="flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800 text-white shadow-lg hover:bg-slate-900 transition-colors text-sm"
      >
        <Download className="w-4 h-4" />
        <span>Install Admin app</span>
      </button>
    </div>
  )
}

export default InstallAppPrompt

